
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"21","viewBox":"0 0 20 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"1","y":"1.116","width":"18","height":"18","rx":"9","fill":"#fff"}}),_c('g',{attrs:{"clip-path":"url(#start-video_svg__clip0_892_39136)"}},[_c('path',{attrs:{"d":"M7.4 6.92v6.033c0 .46.516.738.91.492l4.816-3.017a.577.577 0 000-.982L8.31 6.429c-.394-.247-.91.032-.91.491z","fill":"#122546"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"start-video_svg__clip0_892_39136"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(6.606 5.873)","d":"M0 0h6.789v8.486H0z"}})])])])
          )
        }
      }
    